// FeaturesSection.js
import React from 'react';
import './Features.css';

const featuresData = [
  {
    icon: 'bi bi-slash-circle',
    title: 'No Spam Calls',
    description: 'Unlike other matrimony apps, we never call or pressure you to buy premium. Your journey is yours to control—no unwanted calls, just a smooth and respectful matchmaking experience.',
  },
  {
    icon: 'bi bi-mic',
    title: 'Audio Introduction',
    description: 'Record a short audio introduction to let potential matches hear your voice and personality. A more personal way to make a great first impression and express yourself authentically.',
  },
  {
    icon: 'bi bi-person-video3',
    title: 'Video Introduction',
    description: 'Upload a short video to introduce yourself in a natural and engaging way. Stand out from the crowd by letting matches see and hear you before starting a conversation.',
  },
  {
    icon: 'bi bi-gem',
    title: 'Try Before You Buy',
    description: 'Explore premium features before committing to an upgrade. Get a feel for the enhanced experience and decide at your own pace—no pressure, just a seamless matchmaking journey.',
  },
  {
    icon: 'bi bi-ui-checks',
    title: 'Clean & User-Friendly',
    description: 'Enjoy a smooth, hassle-free experience with our modern and intuitive design. Easily browse profiles, connect with matches, and navigate effortlessly, making your journey simple and enjoyable.',
  },
  {
    icon: 'bi bi-person-check',
    title: 'Verified Profiles',
    description: 'Every profile is manually verified to ensure authenticity and trust. Say goodbye to fake accounts and interact confidently with genuine people looking for meaningful relationships.',
  },
  {
    icon: 'bi bi-chat-dots',
    title: 'Chat & Connect',
    description: 'Start conversations instantly with potential matches through our secure and private chat system. No waiting—just real-time, meaningful interactions that bring you closer to finding your ideal partner.',
  },
  {
    icon: 'bi bi-camera-video',
    title: 'Video & Voice Calls',
    description: 'Connect safely with matches using built-in video and voice calls—no need to share contact details. Have meaningful conversations before meeting in person, ensuring trust and comfort.',
  },
];

const Features = () => {
  return (
    <div className="features-section">
      <div className="features-container">
        <h1>Why choose Vihana Matrimony</h1>
        <p>Explore the exceptional features that make Vihana Matrimony the perfect place to find your life partner.</p>
        <div className="features-content">
          {featuresData.map((feature, index) => (
            <div key={index} className="feature-item">
              {feature.title === 'Hangman Game' ? (
              <img src={feature.src} alt={`${feature.title} Icon`} />
            ) : (
              <i className={feature.icon}></i>
            )}
              <h3>{feature.title}</h3>
              <p>{feature.description}</p>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default Features;
